module.exports = __webpack_public_path__ + "static/img/backgourp_main.5911568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recharge/mobile/backgourp_main.png
// module id = hFUn
// module chunks = 1